import type { AxiosResponse } from 'axios';

import axiosInstance from '../../instance';
import ROUTES from '../../routes';
import type { DeviceProfilePostBody, IDeviceProfile } from './types';

export const getAll = (): Promise<void | AxiosResponse<IDeviceProfile []>> => axiosInstance({
  url: `${ROUTES.DEVICE_PROFILES}`,
  method: 'GET',
  headers: {
    authorization: true,
  },
});

export const getById = (id: string): Promise<void | AxiosResponse<IDeviceProfile>> => axiosInstance({
  url: `${ROUTES.DEVICE_PROFILES}/${id}`,
  method: 'GET',
  headers: {
    authorization: true,
  },
});

export const create = (data: DeviceProfilePostBody, id: string)
  : Promise<void | AxiosResponse<{ result: 0 }>> => axiosInstance({
  url: `${ROUTES.DEVICE_PROFILES}/${id}`,
  method: 'POST',
  headers: {
    authorization: true,
  },
  data,
});

export const remove = (id: string): Promise<void | AxiosResponse<{ result: 0 }>> => axiosInstance({
  url: `${ROUTES.DEVICE_PROFILES}/${id}`,
  method: 'DELETE',
  headers: {
    authorization: true,
  },
});
